import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import ChartBase from '../ChartBase/ChartBase.js';
import { getChartBaseProps, getHighLowChartProps, highlightDataProps } from '../ChartBase/ChartBaseFunctions.js';
import { IChartBaseProps } from '../ChartBase/models/index.js';

import { IScatterChartConfiguration, IScatterChartProps, IScatterChartState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { SCATTER_CHART_CATEGORY_KEY, SCATTER_CHART_COMPONENT_KEY } from './ScatterChart.meta.js';

export class ScatterChart extends ComponentBase<IScatterChartProps, IScatterChartState, IScatterChartConfiguration> {
	categoryKey = SCATTER_CHART_CATEGORY_KEY;
	componentKey = SCATTER_CHART_COMPONENT_KEY;

	constructor(props: IScatterChartProps) {
		super(props);
	}

	get chartBaseProps(): IChartBaseProps {
		let chartProps = this.props;
		if (chartProps.highLowBubbleChartProps) {
			chartProps = getHighLowChartProps(this.props);
		}
		if (chartProps.highlightDataPointProps) {
			chartProps = highlightDataProps(chartProps);
		}
		return getChartBaseProps({ type: 'Scatter' }, this.configuration, chartProps);
	}

	render() {
		const { className } = this.props;
		return (
			<Wrapper className={className}>
				<ChartBase {...this.chartBaseProps} />
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(ScatterChart), SCATTER_CHART_CATEGORY_KEY, SCATTER_CHART_COMPONENT_KEY);
